import Request from './Request';

export default Request;



// WEBPACK FOOTER //
// ./src/scenes/Requests/components/Request/index.ts